import './StatementsFilters.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getQueryStringParams } from 'support/BrowserUtils';
import {
  selectStatementsDocumentTypes,
  selectStatementsTimePeriod,
  selectStatementsProductTypes
} from 'state/statements/StatementsActions';
import {
  ALL_DOCUMENT_TYPES,
  getNonViewOnlyProductTypeOptions,
  STATEMENTS_DOC_SELECTION,
  getStatementsFilteringSelections
} from 'state/statements/StatementsSelectors';
import { getNonViewOnlyProducts } from 'state/account/AccountSelectors';
import {
  priorYear,
  currentYear,
  mapStatementsProductName
} from 'services/Statements';
import Store from 'state/Store';
import Option from 'components/shared/SelectOption/Option';
import { AAMBeaconControl } from 'components/shared/Beacon';

const selectTimePeriod = (event) => {
  Store.dispatch(selectStatementsTimePeriod(event.target.value));
};

const selectDocumentTypes = (event) => {
  Store.dispatch(selectStatementsDocumentTypes(event.target.value));
};

const selectProductTypes = (event) => {
  Store.dispatch(selectStatementsProductTypes(event.target.value));
};

const showProductFilters = (
  statementsFilteringSelections,
  nonViewOnlyProducts
) => {
  const { documentTypes } = statementsFilteringSelections;
  return (
    documentTypes.selection !== ALL_DOCUMENT_TYPES &&
    documentTypes.selection !== STATEMENTS_DOC_SELECTION &&
    nonViewOnlyProducts.length > 1
  );
};

const shouldResetProductType = (prevProps, statementsFilteringSelections) => {
  const { documentTypes } = statementsFilteringSelections;
  const {
    statementsFilteringSelections: {
      documentTypes: { selection }
    }
  } = prevProps;
  //We need to reset to the single product type if document type selection is anything but statements or all since the product type is set to 'all' when they are selected.
  //Tax Forms and Confirms have product type filter, if there is only one product type in the users accounts, we want to default to that.
  return (
    selection !== documentTypes.selection &&
    documentTypes.selection !== STATEMENTS_DOC_SELECTION &&
    documentTypes.selection !== ALL_DOCUMENT_TYPES
  );
};

class StatementsFilters extends React.Component {
  componentDidMount() {
    const { statementsFilteringSelections } = this.props;
    const { documentTypes } = statementsFilteringSelections;
    let params = {};
    getQueryStringParams().forEach((pair) => {
      const keyValueArray = Object.entries(pair)[0];
      const param = { [keyValueArray[0]]: keyValueArray[1] };

      params = {
        ...params,
        ...param
      };
    });
    const { year, documentFilter } = params;
    if (
      documentFilter &&
      documentTypes.options.find((o) => o.value === documentFilter)
    ) {
      if (year && year === 'prior') {
        Store.dispatch(selectStatementsTimePeriod(priorYear.toString()));
      } else {
        //Default to current year if year is not supplied in the URL because 2 out of the 3 doc types are mainly relevant for current year
        Store.dispatch(selectStatementsTimePeriod(currentYear.toString()));
      }
      Store.dispatch(selectStatementsDocumentTypes(documentFilter));
    }
  }

  componentDidUpdate(prevProps) {
    const { nonViewOnlyProducts, statementsFilteringSelections } = this.props;
    const resetProductTypeRule = shouldResetProductType(
      prevProps,
      statementsFilteringSelections
    );
    if (
      prevProps.nonViewOnlyProducts !== nonViewOnlyProducts ||
      resetProductTypeRule
    ) {
      if (nonViewOnlyProducts.length === 1) {
        const productType = mapStatementsProductName(nonViewOnlyProducts);
        Store.dispatch(selectStatementsProductTypes(productType));
      }
    }
  }

  render() {
    const {
      statementsFilteringSelections,
      productsOptions,
      nonViewOnlyProducts
    } = this.props;
    const { documentTypes, timePeriod, productTypes } =
      statementsFilteringSelections;
    const showProductFilter = showProductFilters(
      statementsFilteringSelections,
      nonViewOnlyProducts
    );

    return (
      <div className="statements-filters beacon-on-light">
        <div className="statements-filters-preamble">
          <p>
            View previous 7 years of statements, confirmations, and tax forms.
            Please note that documents for accounts for which the Taxpayer
            Identification Number (TIN) or Social Security number (SSN) differs
            from the TIN/SSN of the logged in user may not be visible. Other
            documents, if applicable, from the prior year are also available.
          </p>
        </div>
        <div className="statements-filters-group">
            <Fragment>
              <div className="select-group">
                <AAMBeaconControl>
                  <label slot="label" htmlFor="document-types-select">Document Types</label>
                  <select id="document-types-select"
                          onChange={selectDocumentTypes}
                          name={name}
                          value={documentTypes.selection || ''} >
                    <option key="default" value="" disabled defaultValue={''}>
                      Select
                    </option>
                    {documentTypes.options.map((option, i) => (
                      <Option key={`${option.value}${i}`} option={option} />
                    ))}
                  </select>
                </AAMBeaconControl>
              </div>
              <div className="select-group">
                <AAMBeaconControl>
                  <label slot="label" htmlFor="time-period-select">Time Period</label>
                  <select id="time-period-select"
                          value={timePeriod.selection}
                          onChange={selectTimePeriod}>
                    {timePeriod.options.map((option, i) => (
                      <Option key={`${option.value}${i}`} option={option} />
                    ))}
                  </select>
                </AAMBeaconControl>
              </div>
                <div className={`select-group ${showProductFilter ? "display-block" : "display-none"}`}>
                  <AAMBeaconControl>
                    <label slot="label" htmlFor="product-types-select">Product Types</label>
                    <select id="product-types-select"
                            onChange={selectProductTypes}
                            value={productTypes.selection || ''}
                            name={name}>
                      <option key="default" value="" disabled defaultValue={''}>
                        Select
                      </option>
                      {productsOptions.map((option, i) => (
                        <Option key={`${option.value}${i}`} option={option} />
                      ))}
                    </select>
                  </AAMBeaconControl>
                </div>
            </Fragment>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  statementsFilteringSelections: getStatementsFilteringSelections(state),
  productsOptions: getNonViewOnlyProductTypeOptions(state),
  nonViewOnlyProducts: getNonViewOnlyProducts(state)
});

export default withRouter(connect(mapStateToProps)(StatementsFilters));
